import { AddressTypeEnum } from '../../api/Argentia/enums/addressTypeEnum'
import { FiscalAddressModel } from '../clients/clients.model'
import { AddressDataFormModel } from './addresses.model'

export const addressMapper = (
  addressFormData: AddressDataFormModel,
  addressType: AddressTypeEnum
): FiscalAddressModel => {
  return (
    addressFormData && {
      Id: addressFormData.fiscalAddressId,
      postalAddress: addressFormData.postalAddress!,
      postalCode: addressFormData.postalCode!,
      municipality: addressFormData.municipality!,
      province: addressFormData.province!,
      country: addressFormData.country!,
      municipalityId: addressFormData.municipalityId,
      provinceId: addressFormData.provinceId!,
      countryId: addressFormData.countryId!,
      cupsId: addressFormData.cupsId,
      paymentMethodId: addressFormData.paymentMethodId,
      addressType: addressType
    }
  )
}

export const mapfiscalAddressToAddressDataFormModel = (
  address: FiscalAddressModel
): AddressDataFormModel => {
  return address
}
